// Фильтры - сброс +
// Таблица - сброс +
// url - логика +
// сохранение последних фильтров (localStorage, по кнопке) +

import customHeaders, { getSpace } from '../../common/headers';
import { useNavigate } from 'react-router-dom';
import { useDataTable } from '../../common/hooks';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { KonstantinMasterHttps } from '../../fetchUrls';
import { useState, useEffect, useRef } from 'react';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { DropDownSelector, TableBox } from '@lk-gtcom/ecomlab-components';
import useGeneralStore from '../../store/general';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { RequestController } from '../../common/filtersFunc';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { useSavedFilters } from '../../common/useSavedFilters';
import './ProductsList.scss';
import { fetchFilterV3 } from '../../common/filtersFunc';

const ProductsList = ({ }) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const requestControllerRef = useRef(new RequestController());
  const navigate = useNavigate();
  
  // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
  const { isReady, saveFilters, clearSavedFilters, isSaved,  hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'products-list');

  // Конфигурация фильтров для URL параметров
  const filterConfig = [
    { key: 'api', type: 'single' },
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' },
    { key: 'offerId', type: 'multi' }
  ];

  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);

  // Состояния для пагинации
  const [apiPage, setApiPage] = useState(1);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);
  const [offerIdPage, setOfferIdPage] = useState(1);

  // Состояния для поисковых запросов
  const [apiQuery, setApiQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');
  const [offerIdQuery, setOfferIdQuery] = useState('');

  // Данные для фильтров
  const [apiData, setApiData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [offerIdData, setOfferIdData] = useState([]);

  // Выбранные значения фильтров
  const [selectedApi, setSelectedApi] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedOfferId, setSelectedOfferId] = useState([{ label: 'Все', value: 'all' }]);

  // Total фильтров
  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0);
  const [totalOfferId, setTotalOfferId] = useState(0);

  // Флаг для отслеживания первой инициализации из URL
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);
  const [isFilterRequest, setIsFilterRequest] = useState(false);

  // Таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;
  const [isModalDeleteProduct, setIsModalDeleteProduct] = useState(false);

  // Инициализация фильтров из URL параметров при первом рендере
  useEffect(() => {
    if (!isReady) return;
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.api) setSelectedApi(urlParams.api);
        if (urlParams.category) setSelectedCategory(urlParams.category);
        if (urlParams.brand) setSelectedBrand(urlParams.brand);
        if (urlParams.offerId) setSelectedOfferId(urlParams.offerId);

        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams, isReady]);

  // Первая инициализация url
  useEffect(() => {
    if (!isReady) return;
    updateURL({
      api: urlParams?.api || selectedApi,
      category: urlParams?.category || selectedCategory,
      brand: urlParams?.brand || selectedBrand,
      offerId: urlParams.offerId || selectedOfferId,
    })
  }, [isReady]);

  // Таблица
  const fetchTableData = (params, abortController = new AbortController()) => {
    // Не делаем запрос если нет выбранного API (кроме случая когда есть параметры из URL)
    if (!selectedApi?.value) {
      resetTable()
      return;
    }

    let sort;
    let filters;

    if (params) {
      [sort, filters] = params;
    }
    setLoading(true);

    let url = `${KonstantinMasterHttps}/mp-products/tables/product-list${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''}`

    const body = JSON.stringify({
      api_id_list: getValueMultiFilter(selectedApi),
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      offer_id_list: getValueMultiFilter(selectedOfferId),
      limit: paginatorRef.current.limit,
      page: paginatorRef.current.page,
      filters,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then((res) => res.json())
      .then((json) => setTable(json))
      .catch((err) => console.error(err))
      .finally(() => {
        if (abortController?.signal.aborted) return
        setLoading(false)
      })
  };

  const resetTable = () => {
    paginatorRef.current.reset();
    paginatorRef.current.setTotal(0);
    setSort({});
    setHeaders([]);
    setFetchedData([]);
  };

  useEffect(() => {
    const abortController = new AbortController();
    if (isInitialized) {
      fetchTableData([], abortController);
    }
    return () => abortController.abort();
  }, [isTableRequest]);

  // Остальные функции фильтров остаются без изменений
  const filtersApi = () => {
    const controller = requestControllerRef.current.createController('api');

    fetchFilterV3({
      selectedSpace: selectedSpace?.value,
      page: apiPage,
      set: setApiData,
      searchParam: apiQuery,
      controller,
      setTotal: setTotalApi,
      filter: 'mp_product_api_ids'
    })?.finally(() => {
      requestControllerRef.current.removeController('api');
    })
  };

  const filtersCategory = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchFilterV3({
      selectedSpace: selectedSpace?.value,
      selectedApi,
      page: categoryPage,
      set: setCategoryData,
      searchParam: categoryQuery,
      controller,
      setTotal: setTotalCategory,
      filter: 'mp_product_categories'
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  };

  const filtersBrand = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchFilterV3({
      selectedSpace: selectedSpace?.value,
      page: brandPage,
      selectedApi,
      selectedCategory,
      searchParam: brandQuery,
      set: setBrandData,
      controller,
      setTotal: setTotalBrand,
      filter: 'mp_product_brands'
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  };

  const filtersOfferId = () => {
    const controller = requestControllerRef.current.createController('offer');

    fetchFilterV3({
      selectedSpace: selectedSpace?.value,
      selectedApi,
      selectedCategory,
      selectedBrand,
      page: offerIdPage,
      set: setOfferIdData,
      searchParam: offerIdQuery,
      controller,
      setTotal: setTotalOfferId,
      filter: 'mp_product_offer_id_name'
    })?.finally(() => {
      requestControllerRef.current.removeController('offer');
    })
  };

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersApi();
  }, [isFilterRequest, apiPage, apiQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersCategory();
  }, [isFilterRequest, categoryPage, categoryQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersBrand();
  }, [isFilterRequest, brandPage, brandQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersOfferId();
  }, [isFilterRequest, offerIdPage, offerIdQuery]);

  useEffect(() => {
    return () => {
      requestControllerRef.current.abortAll();
    };
  }, []);

  // Обработчик сброса фильтров
  const handleResetFilters = () => {
    setSelectedApi([]);
    setSelectedCategory([]);
    setSelectedBrand([]);
    setSelectedOfferId([]);
    updateURL({
      api: null,
      category: null,
      brand: null,
      offerId: null,
      dateFrom: null,
      dateTo: null
    });
    setIsTableRequest(!isTableRequest);
    setIsFilterRequest(!isFilterRequest)
    resetTable();
  };

  const contextMenuArr = [
    {
      label: 'Информация',
      onClick: (e) => {
        const offer_id = e?.['Товар']?.[4];
        window.open(`/analysis_mp_product/general?nmid=${offer_id}&apiId=${selectedApi?.value}`);
      },
      type: '',
    },
    {
      label: 'Список связок',
      onClick: () => window.open('/analysis_mp_product/general'),
      type: '',
    },
  ];

  return (
    <>
      <div className="products-list">
        <TitlePage title='Список товаров' />

        <FilterContainer
          loading={isSaved}
          saveFilters={saveFilters}
          clearSavedFilters={clearSavedFilters}
        hasSavedFilters={hasSavedFilters}
          onReset={handleResetFilters}
        >
          <DropDownSelector
            options_prop={apiData}
            state={selectedApi}
            setState={setSelectedApi}
            placeholder="Магазин"
            total={totalApi}
            fetchCallback={setApiPage}
            setInputChange={setApiQuery}
            onBlur={(e) => {
              updateURL({ api: selectedApi });
              filtersCategory();
              filtersBrand();
              filtersOfferId();
              setIsTableRequest(!isTableRequest)
            }}
          />

          <DropDownSelector
            options_prop={categoryData}
            state={selectedCategory}
            setState={setSelectedCategory}
            placeholder="Категория"
            total={totalCategory}
            multi={true}
            fetchCallback={setCategoryPage}
            setInputChange={setCategoryQuery}
            onBlur={(e) => {
              updateURL({ category: selectedCategory });
              filtersBrand();
              filtersOfferId();
              setIsTableRequest(!isTableRequest)
            }}
          />

          <DropDownSelector
            options_prop={brandData}
            state={selectedBrand}
            setState={setSelectedBrand}
            placeholder="Бренд"
            total={totalBrand}
            multi={true}
            fetchCallback={setBrandPage}
            setInputChange={setBrandQuery}
            onBlur={(e) => {
              updateURL({ brand: selectedBrand });
              filtersOfferId();
              setIsTableRequest(!isTableRequest)
            }}
          />
          <DropDownSelector
            options_prop={offerIdData}
            state={selectedOfferId}
            setState={setSelectedOfferId}
            placeholder="OfferId"
            total={totalOfferId}
            multi={true}
            fetchCallback={(e) => setOfferIdPage(e)}
            setInputChange={(e) => setOfferIdQuery(e)}
            onBlur={(e) => {
              updateURL({ offerId: selectedOfferId });
              setIsTableRequest(!isTableRequest)
            }}
          />
        </FilterContainer>

        <TableBox
          {...tableProps}
          paginator={true}
          ref={paginatorRef}
          fetchCallback={fetchTableData}
          onEdit={(e) => navigate('/edit-product/add-information/required')}
          onDelete={(e) => setIsModalDeleteProduct(true)}
          contextMenuArr={contextMenuArr}
        />
      </div>
    </>
  );
};

export { ProductsList };